import React, { Component } from 'react';
import { connect } from 'react-redux';
import { taskTypeIdSelector } from '../../../reducers/elementTypes';
import { iconsSelector } from '../../../reducers/icons';
import { flatTaskDsmIdSelector, ppcGraphIdSelector, rootCauseGraphIdSelector } from '../../../reducers/project';
import { currentUserSelector } from '../../../reducers/users';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import IconNavList from './IconNavList';

const IconNavContainerSelector = immutableCreatorSelector(
  [
    iconsSelector,
    taskTypeIdSelector,
    flatTaskDsmIdSelector,
    ppcGraphIdSelector,
    rootCauseGraphIdSelector,
    currentUserSelector,
  ],
  (
    icons,
    taskTypeId,
    flatTaskDsmId,
    ppcGraphId,
    rootCauseGraphId,
    currentUser,
  ) => ({
    icons,
    taskTypeId,
    flatTaskDsmId,
    ppcGraphId,
    rootCauseGraphId,
    currentUser,
  }),
);

@connect(IconNavContainerSelector)
export default class IconNavListContainer extends Component {
  render() {
    return <IconNavList {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/IconNavListContainer.js